import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { timeout } from 'rxjs/operators';

import { map, Observable, switchMap } from 'rxjs';

import { Container, FullDetails, recordVideos, UserData, Video, VideoResponse } from 'src/app/models/interviewModel';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InterviewVideoApiService {
  private apiUrl = environment.apiUrl

  constructor(private http: HttpClient) { }
  
  getAdminVideos(): Observable<Container> {
    return this.http.get<string>(this.apiUrl + 'auth/' + 'getAdminId')
      .pipe(
        timeout(30000), 
        switchMap(id => this.getInterviewVideos(id))
      );
  }
 
  getInterviewVideos(id:string): Observable<Container> {
    console.log(id);
    
    return this.http.get<Container>(this.apiUrl+'api/'+'get-interview-videos/'+id).pipe(
     map(res=>(
       {
        description: res.description,
         title:res.title,
         videos: res.videos ? res.videos.map(video => ({
            duration: video.duration,
            url: this.apiUrl + video.url,
            title:video.title,
            videoId:video.videoId
         })) : []
       }
      ))
    );
  }

  uploadRecordVideos(records:recordVideos){
    console.log(records);
    
    let from=new FormData();
    records.title="user recorder";
    
    from.append("title",records.title);
    from.append('duration',"60");
    from.append('description',"asdfasfasdf");
    from.append("feedbackResponse",records.feedbackResponse)
    records.files.forEach((file:Blob) => {
      from.append(`videos`, file,'recording.webm');
    });
   return this.http.post(this.apiUrl+"api/upload-record-video",from);
    
  }
  }
